<template>
    <div data-cy="plugin-settings-edit-domains-modal">
        <Modal size="md" @close="$emit('close')">
            <template #header>
                <div class="text-gray-600">
                    <span v-if="!currentSettings">Setup your own </span>
                    <span v-else>Edit </span>

                    <span v-if="provider === 'gcs'">Google Cloud</span>
                    <span v-else-if="provider === 'aws'">Amazon S3</span>
                    <span v-else-if="provider === 'digitalocean'">DigitalOcean Spaces</span>
                    <span v-else>Cloudflare R2</span>
                    bucket
                </div>
            </template>

            <template #body>
                <div class="p-6">
                    <div>
                        <TextInput
                            v-model="v$.form.settings.name.$model"
                            placeholder="Enter your bucket name"
                            label="Bucket name"
                            :error="getError('name')"
                            required
                        />

                        <TextInput
                            v-if="
                                provider === 'aws' ||
                                provider === 'gcs' ||
                                provider === 'digitalocean'
                            "
                            v-model="v$.form.settings.region.$model"
                            class="mt-6"
                            :placeholder="
                                provider === 'digitalocean'
                                    ? 'nyc3'
                                    : 'europe-west3'
                            "
                            label="Region"
                            :error="getError('region')"
                            required
                        />

                        <TextInput
                            v-if="provider === 'gcs'"
                            v-model="state.form.settings.email"
                            class="mt-6"
                            placeholder="myowntopolioplugin@example-io.iam.gserviceaccount.com"
                            label="Client Email"
                            :error="getError('email')"
                            required
                            @blur="v$.form.settings.email.$touch()"
                        />

                        <TextInput
                            v-if="provider === 'cloudflare'"
                            v-model="v$.form.settings.account_id.$model"
                            class="mt-6"
                            placeholder="Account ID"
                            label="Account ID"
                            :error="getError('account_id')"
                            required
                        />

                        <TextInput
                            v-if="provider === 'gcs'"
                            v-model="v$.form.settings.project_id.$model"
                            class="mt-6"
                            placeholder="My-own-google-project-id"
                            label="Project ID"
                            required
                            :error="getError('projectID')"
                        />

                        <TextInput
                            v-if="
                                provider === 'aws' ||
                                provider === 'cloudflare' ||
                                provider === 'digitalocean'
                            "
                            v-model="v$.form.settings.access_key.$model"
                            class="mt-6"
                            placeholder="Enter your access key"
                            label="Access key"
                            required
                            :error="getError('access_key')"
                        />

                        <TextAreaInput
                            class="mt-6"
                            :placeholder="
                                provider === 'cloudflare' ||
                                provider === 'digitalocean'
                                    ? 'Enter your secret key'
                                    : 'Enter your private key'
                            "
                            :label="
                                provider === 'cloudflare' ||
                                provider === 'digitalocean'
                                    ? 'Secret key'
                                    : 'Private key'
                            "
                            required
                            :error="getError('private_key')"
                            :model-value="state.form.settings.private_key"
                            @update:model-value="handleUpdatePrivateKey"
                            @focus="clearMaskedPrivateKey"
                            @blur="v$.form.settings.private_key.$touch()"
                        />

                        <TextInput
                            v-if="
                                provider === 'cloudflare' ||
                                provider === 'aws' ||
                                provider === 'digitalocean'
                            "
                            v-model="v$.form.settings.url.$model"
                            class="mt-6"
                            :required="provider === 'cloudflare'"
                            :placeholder="
                                provider === 'aws'
                                    ? 'https://d111111abcdef8.cloudfront.net'
                                    : provider === 'digitalocean'
                                      ? 'https://example.nyc3.digitaloceanspaces.com'
                                      : 'https://example.cloudflare.com'
                            "
                            :label="
                                provider === 'aws'
                                    ? 'CloudFront URL'
                                    : 'Public URL'
                            "
                            :error="getError('url')"
                        />

                        <TextInput
                            v-if="provider === 'cloudflare'"
                            v-model="
                                v$.form.settings.jurisdiction
                                    .$model
                            "
                            class="mt-6"
                            placeholder="eu"
                            label="Jurisdiction"
                            :error="getError('jurisdiction')"
                        />
                    </div>
                    <div class="mt-6 pb-[5px]">
                        <p class="text-sm leading-normal text-gray-500">
                            For more information how to setup
                            <span v-if="provider === 'gcs'">Google Cloud</span>
                            <span v-else-if="provider === 'aws'"
                                >Amazon S3</span
                            >
                            <span v-else-if="provider === 'digitalocean'"
                                >DigitalOcean Spaces</span
                            >
                            <span v-else>Cloudflare R2</span>
                            bucket please <br />
                            <a
                                :href="
                                    allProviders.find(
                                        (p) => p.key === provider
                                    )?.docUrl
                                "
                                target="_blank"
                                class="font-medium text-topol-blue-500 hover:text-topol-blue-600"
                                >check out our documentation</a
                            >.
                        </p>
                    </div>
                </div>
                <div
                    v-if="currentSettings?.storage_provider"
                    class="border-t border-gray-200 p-6 px-6 pb-[18px] pt-4"
                >
                    <div class="text-sm font-medium text-gray-700">
                        Detach
                        <span>
                            {{
                                allProviders.find((p) => p.key === provider)
                                    ?.name
                            }}</span
                        >
                        bucket
                    </div>
                    <div class="mt-[7px] text-sm">
                        After detaching
                        <span>
                            {{
                                allProviders.find((p) => p.key === provider)
                                    ?.name
                            }}</span
                        >
                        bucket, all of your Plugin users won't be able to access
                        files on your storage. You can reconnect your storage
                        bucket again later.
                    </div>
                    <button
                        class="mt-4 text-sm font-medium text-topol-blue-500 hover:text-topol-blue-600"
                        @click="$emit('deleteModal')"
                    >
                        Begin detaching
                        <span>
                            {{
                                allProviders.find((p) => p.key === provider)
                                    ?.name
                            }}</span
                        >
                        bucket
                    </button>
                </div>
            </template>

            <template #footer>
                <div class="flex justify-between border-t border-gray-200 p-6">
                    <AtomicButton
                        color="white"
                        size="md"
                        data-cy="plugin-settings-update-domains-cancel"
                        @click="$emit('close')"
                    >
                        Cancel
                    </AtomicButton>

                    <LockableButton
                        size="md"
                        color="yellow"
                        :disabled="
                            loading || v$.$invalid || !hasStorageSettingsEnabled
                        "
                        type="submit"
                        :locked="!hasStorageSettingsEnabled"
                        lock-message="You need a Plugin subscription (Plugin Expansion or higher) to use this feature."
                        @click="saveStorage"
                    >
                        <span v-if="!currentSettings">Finish setup</span>
                        <span v-else>Update custom storage</span>
                    </LockableButton>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';
import { create } from '@/composables/useNotifications';
import { route } from 'ziggy-js';
import { router } from '@inertiajs/vue3';
import useVuelidate from '@vuelidate/core';
import { required, requiredIf, maxLength, email } from '@vuelidate/validators';
import IToken from '@/types/Plugin/IToken';
import IInputErrors from '@/types/Atomic/IInputErrors';
import ITokenSettings from '@/types/Plugin/ITokenSettings';
import { allProviders } from '../data/storageProviders';

const props = defineProps({
    token: {
        type: Object as PropType<IToken>,
        required: true,
    },
    provider: {
        type: String as PropType<'aws' | 'gcs' | 'cloudflare' | 'digitalocean'>,
        required: true,
    },
    hasStorageSettingsEnabled: {
        type: Boolean,
        default: false,
    },
    page: {
        type: Number,
        default: 1,
    },
});

const emit = defineEmits(['close', 'save', 'deleteModal']);

const currentSettings = computed<ITokenSettings | null>(
    () => props.token.settings ?? null
);

const loading = ref(false);
const errors = ref<IInputErrors>({});

const state = reactive({
    form: {
        settings: {
            name: '',
            region: '',
            email: '',
            project_id: '',
            access_key: '',
            private_key: '',
            url: '',
            jurisdiction: '',
            account_id: '',
            aws: false,
            gcs: false,
            cloudflare: false,
            digitalocean: false,
        },
    },
});

const rules = {
    form: {
        settings: {
            name: {
                required,
                maxLength: maxLength(255),
            },
            region: {
                required: requiredIf(
                    () =>
                        props.provider === 'gcs' ||
                        props.provider === 'aws' ||
                        props.provider === 'digitalocean'
                ),
                maxLength: maxLength(255),
            },
            email: {
                required: requiredIf(() => props.provider === 'gcs'),
                maxLength: maxLength(255),
                email,
            },
            project_id: {
                required: requiredIf(() => props.provider === 'gcs'),
                maxLength: maxLength(255),
            },
            access_key: {
                required: requiredIf(
                    () =>
                        props.provider === 'aws' ||
                        props.provider === 'cloudflare' ||
                        props.provider === 'digitalocean'
                ),
                maxLength: maxLength(255),
            },
            private_key: {
                required,
            },
            url: {
                required: requiredIf(() => props.provider === 'cloudflare'),
                maxLength: maxLength(255),
            },
            account_id: {
                required: requiredIf(() => props.provider === 'cloudflare'),
                maxLength: maxLength(255),
            },
            jurisdiction: {
                maxLength: maxLength(255),
            },
        },
    },
};
const v$ = useVuelidate(rules, state);

// The modal is reused for a different provider without remounting (for example
// after detaching one bucket and setting up another), so the provider flags and
// the prefilled fields have to follow the `provider` prop, not the mount.
watch(
    () => props.provider,
    (provider) => {
        Object.assign(state.form.settings, {
            name: '',
            region: '',
            email: '',
            project_id: '',
            access_key: '',
            private_key: '',
            url: '',
            jurisdiction: '',
            account_id: '',
            aws: provider === 'aws',
            gcs: provider === 'gcs',
            cloudflare: provider === 'cloudflare',
            digitalocean: provider === 'digitalocean',
        });

        const settings = props.token.settings;

        if (settings?.storage_provider === provider) {
            if (provider === 'gcs') {
                state.form.settings.name = settings.storage_gcs_bucket ?? '';
                state.form.settings.region = settings.storage_gcs_region ?? '';
                state.form.settings.project_id =
                    settings.storage_gcs_project_id ?? '';
                state.form.settings.email =
                    settings.storage_gcs_client_email ?? '';
                state.form.settings.private_key =
                    settings.storage_gcs_private_key ?? '';
            } else if (provider === 'aws') {
                state.form.settings.name = settings.storage_aws_bucket ?? '';
                state.form.settings.region = settings.storage_aws_region ?? '';
                state.form.settings.access_key =
                    settings.storage_aws_access_key ?? '';
                state.form.settings.private_key =
                    settings.storage_aws_secret_key ?? '';
                state.form.settings.url =
                    settings.storage_aws_cloudfront_url ?? '';
            } else if (provider === 'cloudflare') {
                state.form.settings.name =
                    settings.storage_cloudflare_bucket ?? '';
                state.form.settings.url =
                    settings.storage_cloudflare_public_url ?? '';
                state.form.settings.account_id =
                    settings.storage_cloudflare_account_id ?? '';
                state.form.settings.access_key =
                    settings.storage_cloudflare_access_key ?? '';
                state.form.settings.private_key =
                    settings.storage_cloudflare_secret_key ?? '';
                state.form.settings.jurisdiction =
                    settings.storage_cloudflare_jurisdiction ?? '';
            } else if (provider === 'digitalocean') {
                state.form.settings.name =
                    settings.storage_digitalocean_bucket ?? '';
                state.form.settings.region =
                    settings.storage_digitalocean_region ?? '';
                state.form.settings.access_key =
                    settings.storage_digitalocean_access_key ?? '';
                state.form.settings.private_key =
                    settings.storage_digitalocean_secret_key ?? '';
                state.form.settings.url =
                    settings.storage_digitalocean_public_url ?? '';
            }
        }

        errors.value = {};
        v$.value.$reset();
    },
    { immediate: true }
);

const saveStorage = () => {
    v$.value.$touch();
    if (v$.value.$error) {
        return;
    } else {
        loading.value = true;
        router.put(
            route('api-tokens.storage.update', props.token.id),
            { ...state.form, page: props.page },
            {
                only: ['tokens'],
                preserveState: true,
                preserveUrl: true,
                preserveScroll: true,
                onSuccess: () => {
                    emit('close');
                    create({
                        title: 'Settings updated',
                        text: 'Your API Token settings has been successfully updated.',
                        type: 'success',
                    });
                },
                onError: (e) => {
                    create({
                        title: 'Settings not updated',
                        text:
                            e?.error ||
                            'There has been an error updating your API Token settings.',
                        type: 'error',
                    });
                },
                onFinish: () => {
                    loading.value = false;
                },
            }
        );
    }
};

const handleUpdatePrivateKey = (value: string) => {
    const updatedValue = value.replaceAll('\\n', '\n');
    state.form.settings.private_key = updatedValue;
};

// The secret is prefilled with a masked placeholder (contains •); clear it on
// focus so the user types a fresh secret instead of appending to the mask.
const clearMaskedPrivateKey = () => {
    if (state.form.settings.private_key.includes('•')) {
        state.form.settings.private_key = '';
    }
};

const getError = (field: string) => {
    return (
        v$.value.form.settings[field]?.$errors[0]?.$message ||
        errors.value?.[field] ||
        ''
    );
};
</script>

<style></style>
